import Component from '@glimmer/component'
import { tracked } from '@glimmer/tracking'
import { formatDate } from 'ember-intl'
import { fn } from '@ember/helper'
import { InputText } from 'teacher-ui-client/components/base/input-text'
import type { ThemeKeys } from 'teacher-ui-client/utils/themes'
import PopoverStandardDropdown from '@blakeelearning/popovers/components/popover/dropdowns/standard'
import { CalendarNav } from 'teacher-ui-client/components/dates/calendar-nav'
import { CalendarTable } from 'teacher-ui-client/components/dates/calendar-table'
import type Owner from '@ember/owner'

interface Signature {
  Element: HTMLInputElement
  Args: {
    date: Date
    onDateSelect: (date: Date) => unknown
    min: Date
    max?: Date
    themeKey?: ThemeKeys
  }
}

export class TwoDatePickerInput extends Component<Signature> {
  @tracked center: Date

  constructor(owner: Owner, args: Signature['Args']) {
    super(owner, args)
    this.center = this.args.date
  }

  onCenterChange = (date: Date) => {
    this.center = date
  }

  onDateSelect = (closeAction: () => unknown, date: Date) => {
    this.args.onDateSelect(date)
    closeAction()
  }

  <template>
    <PopoverStandardDropdown as |dropdown _status actions|>
      <InputText
        type="text"
        readonly
        value={{formatDate @date}}
        class="select-none"
        @themeKey={{@themeKey}}
        @icon="calendar-regular"
        @iconStart={{true}}
        {{dropdown.makeTrigger}}
        ...attributes
      />
      <dropdown.content>
        <div data-test-date-picker class="border-dusty-black-100 my-px rounded-md border bg-white shadow-xl">
          <div class="p-3">
            <CalendarNav @center={{this.center}} @onCenterChange={{this.onCenterChange}} />
            <CalendarTable
              class="w-80"
              @center={{this.center}}
              @onSelectDate={{fn this.onDateSelect actions.close}}
              @start={{@date}}
              @min={{@min}}
              @max={{@max}}
            />
          </div>
        </div>
      </dropdown.content>
    </PopoverStandardDropdown>
  </template>
}

export default TwoDatePickerInput
